import {
  makeGetRequest,
  makePostRequest,
  makePutRequest,
  makeDeleteRequest
} from "../makeRequest";
import config from "../../config/app.config";

const BASE_URL = `${config.apiUrl.bannerapi}`;

// Create a new promo coupon
export const createPromoCoupon = async (data) => {
  try {
    const response = await makePostRequest(BASE_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get all promo coupons
export const getAllPromoCoupons = async () => {
  try {
    const response = await makeGetRequest(BASE_URL);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get active promo coupons
export const getActivePromoCoupons = async () => {
  try {
    const response = await makeGetRequest(`${BASE_URL}/active`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get promo coupon by ID
export const getPromoCouponById = async (id) => {
  try {
    const response = await makeGetRequest(`${BASE_URL}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Update promo coupon
export const updatePromoCoupon = async (id, data) => {
  try {
    const response = await makePutRequest(`${BASE_URL}/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete promo coupon
export const deletePromoCoupon = async (id) => {
  try {
    const response = await makeDeleteRequest(`${BASE_URL}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Helper function to format banner data
export const formatBannerData = (banner) => ({
  linkUrl: banner.linkUrl || '',
  sequenceNo: banner.sequenceNo || 1,
  title: banner.title || '',
  imageUrl: banner.imageUrl || '',
  startDate: banner.startDate || Date.now(),
  endDate: banner.endDate || (Date.now() + 30 * 24 * 60 * 60 * 1000), // 30 days from now
  pageType: banner.pageType || ['all']
});

// Helper function to format promo coupon data
export const formatPromoCouponData = (data) => ({
  type: data.type || 'web',
  state: data.state || 'ALL_USERS',
  viewport: data.viewport || 'abound-earn-banner',
  height: data.height || 230,
  width: data.width || 680,
  status: data.status !== undefined ? data.status : true,
  banners: Array.isArray(data.banners) 
      ? data.banners.map(formatBannerData)
      : [formatBannerData(data.banners || {})]
});

// Validate promo coupon
export const validatePromoCoupon = async (data) => {
  try {
    const response = await makePostRequest(`${BASE_URL}/validate`, data);
    return response;
  } catch (error) {
    throw error;
  }
}; 